import length from "rfuncs/functions/length"
import sleep from "workflow/utils/sleep"

const tasks_message = {}
const tasks_running = {}

const workerpool_loader = (...args) => import("workflow/tasks/workerpool").then(m => m.default(...args))

async function* generate_from(task_id) {
    let time = 1

    while (true) {
        while (length(tasks_message[task_id])) {
            yield tasks_message[task_id].shift()
        }
        if (tasks_running[task_id]) {
            await sleep(time)
            time = Math.min(time + 1, 50)
        } else {
            break
        }
    }

    delete tasks_message[task_id]
    delete tasks_running[task_id]
}

export default async ({ task_id, namespace, func, value, finished }) => {
    if (namespace) {
        const start = performance.now()

        console.info(`starting job ${task_id}`, "using", namespace, func)

        // we need to start a task
        tasks_running[task_id] = true
        tasks_message[task_id] = []

        const generator = generate_from(task_id)
        const emit = (progress, progress_id, result) => {
            self.postMessage({ task_id, progress, progress_id, result })
        }

        try {
            const callable = await workerpool_loader(namespace, func)
            const iterable = await callable(generator, emit)

            await self.postMessage({ task_id, started: true })

            for await (const result of iterable) {
                await self.postMessage(
                    { task_id, result },
                    (result && result.transferable) ? [result.transferable] : []
                )
            }
            await self.postMessage({ task_id, finished: true })
        } catch (error) {
            //console.error(error)
            await self.postMessage({
                task_id,
                error: `${error}`,
                finished: true
            })
        }

        console.info(
            `finishing job ${task_id}`,
            "in",
            (performance.now() - start) / 1000,
            "using",
            namespace,
            func
        )
    } else if (finished) {
        tasks_running[task_id] = false
    } else {
        tasks_message[task_id].push(value)
    }
}


